'use client'
import { ToPageButton } from '@/app/ui/parts/default/sp/parts/buttons/toPageButton'
import { serviceType } from '@/lib/service/server'
import { subcategoryType } from '@/lib/subcategory'
import { useEffect, useState } from 'react'

export const ArticleBottomSubcategoryCategoryButton = ({
  service,
  subcategory,
}: {
  service: serviceType
  subcategory: subcategoryType
}) => {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY || window.pageYOffset
      setIsVisible(scrollY > 200)
    }

    // スクロールイベントリスナーを追加
    window.addEventListener('scroll', handleScroll)

    // クリーンアップ関数
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  if (!isVisible) return null
  return (
    <div
      className="fixed bottom-0 left-0 text-center w-full bg-white"
      style={{ zIndex: 30 }}
    >
      <ToPageButton
        text={`${service.prefix} ${subcategory.name}の一覧を見る`}
        href={`/subcategory/${subcategory.subcategory_id}`}
      />
    </div>
  )
}
